import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import {
  getSubmitAction,
  initialAccessorialRate,
  SubmitAccessorialRateAction,
  type AccessorialRate,
} from '../domain/Accessorial'
import { AccessorialRepository } from '../infra/AccessorialRepository'

export type SubmitAccessorialRatesFactoryDependencies = {
  accessorialRepository: AccessorialRepository
}

export function submitAccessorialRatesFactory({
  accessorialRepository,
}: SubmitAccessorialRatesFactoryDependencies) {
  return async function submit(
    carrierInvite: string,
    accessorialRate: AccessorialRate,
    config?: { signal: AbortSignal }
  ) {
    const action = getSubmitAction(accessorialRate)
    if (action === SubmitAccessorialRateAction.Create) {
      return accessorialRepository.createAccessorialRates(carrierInvite, accessorialRate, config)
    }
    if (action === SubmitAccessorialRateAction.Delete) {
      return accessorialRepository.deleteAccessorialRates(carrierInvite, accessorialRate, config)
    }
    if (action === SubmitAccessorialRateAction.Update) {
      return accessorialRepository.updateAccessorialRates(carrierInvite, accessorialRate, config)
    }

    return initialAccessorialRate
  }
}

export async function submitAccessorialRates(
  carrierInvite: string,
  accessorialRate: AccessorialRate,
  config?: { signal: AbortSignal }
) {
  const httpClient = new ShipperGuideClient()
  const accessorialRepository = new AccessorialRepository({ httpClient })
  const submit = submitAccessorialRatesFactory({ accessorialRepository })
  return submit(carrierInvite, accessorialRate, config)
}
